import { alpha } from "@mui/material/styles";

import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";

import pxToRem from "assets/theme/functions/pxToRem";

const { borderWidth } = borders;
const { md } = boxShadows;

const switchTheme = {
  defaultProps: {
    color: "info",
    disableRipple: false,
  },

  styleOverrides: {
    switchBase: ({ theme }) => ({
      color: theme.palette.white.main,

      "&:hover": {
        backgroundColor: alpha(theme.palette.info.main, 0.08),
      },

      "&.Mui-checked": {
        color: theme.palette.white.main,

        "&:hover": {
          backgroundColor: alpha(theme.palette.info.main, 0.08),
        },

        "& .MuiSwitch-thumb": {
          borderColor: theme.palette.info.main,
        },

        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.info.main,
          borderColor: theme.palette.info.main,
          opacity: 1,
        },
      },

      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.3,
      },

      "&.Mui-disabled .MuiSwitch-thumb": {
        backgroundColor: theme.palette.grey[200],
      },

      "&.Mui-focusVisible .MuiSwitch-thumb": {
        boxShadow: `0 0 0 ${pxToRem(4)} ${alpha(theme.palette.info.main, 0.3)}`,
      },
    }),

    thumb: ({ theme }) => ({
      backgroundColor: theme.palette.white.main,
      boxShadow: md,
      border: `${borderWidth[1]} solid ${theme.palette.grey[400]}`,
    }),

    track: ({ theme }) => ({
      width: pxToRem(32),
      height: pxToRem(15),
      backgroundColor: alpha(theme.palette.info.main, 0.15),
      border: `${borderWidth[1]} solid ${alpha(theme.palette.info.main, 0.15)}`,
      opacity: 1,
    }),
  },
};

export default switchTheme;
